var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4272 2.66667H25.7872C27.7472 2.66667 29.3339 4.25254 29.3339 6.21155V11.5689",
    stroke: "#C18344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 11.5555V6.21155C2.66675 4.25254 4.24008 2.66667 6.21341 2.66667H11.5601",
    stroke: "#C18344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3339 20.4312V25.7885C29.3339 27.7475 27.7472 29.3333 25.7872 29.3333H20.4272",
    stroke: "#C18344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 20.4312V25.7885C2.66675 27.7475 4.24008 29.3333 6.21341 29.3333H11.5601",
    stroke: "#C18344",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 8.024H8.67985C8.31166 8.024 8.01318 8.32233 8.01318 8.69033V13.0082C8.01318 13.3762 8.31166 13.6745 8.67985 13.6745H12.9999C13.368 13.6745 13.6665 13.3762 13.6665 13.0082V8.69033C13.6665 8.32233 13.368 8.024 12.9999 8.024Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 18.3124H8.67985C8.31166 18.3124 8.01318 18.6108 8.01318 18.9788V23.2966C8.01318 23.6646 8.31166 23.9629 8.67985 23.9629H12.9999C13.368 23.9629 13.6665 23.6646 13.6665 23.2966V18.9788C13.6665 18.6108 13.368 18.3124 12.9999 18.3124Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.307 8.024H18.987C18.6188 8.024 18.3203 8.32233 18.3203 8.69033V13.0082C18.3203 13.3762 18.6188 13.6745 18.987 13.6745H23.307C23.6752 13.6745 23.9736 13.3762 23.9736 13.0082V8.69033C23.9736 8.32233 23.6752 8.024 23.307 8.024Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3203 18.3124V20.1791",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7866 18.3124H24.4533",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4527 23.7225H19.3594",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/QR-code.65b0b6e82211f2890dd4486040fee895.svg";
export { ForwardRef as ReactComponent };